var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import ZapSvg from './zap.icon.svg';
export const ZapIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: ZapSvg }));
_react_refresh_temp_1 = ZapIcon;
$RefreshReg$(_react_refresh_temp_1, "ZapIcon");
